module.exports = __webpack_public_path__ + "img/swm-logo@2x.4fa62f13.webp";